import React from 'react';
interface LogoMarkProps {
  className?: string;
  title?: string;
}
/**
 * Tiny recreation of the MGS icon motif — angular brackets framing a yellow
 * square. Used as a section marker / bullet throughout the site.
 */
export function LogoMark({
  className = 'h-4 w-4',
  title
}: LogoMarkProps) {
  return <svg viewBox="0 0 32 32" className={className} role={title ? 'img' : undefined} aria-hidden={title ? undefined : true} aria-label={title} data-id="element-107">
      {title ? <title data-id="element-108">{title}</title> : null}
      <g fill="#3d3935" data-id="element-109">
        <path d="M4 3 L12 5 L7 9 Z" data-id="element-110" />
        <path d="M28 4 L26 12 L22 7 Z" data-id="element-111" />
        <path d="M28 29 L20 27 L25 23 Z" data-id="element-112" />
        <path d="M4 28 L6 20 L10 25 Z" data-id="element-113" />
      </g>
      <rect x="11" y="11" width="10" height="10" rx="1.5" fill="#ffcd00" transform="rotate(6 16 16)" data-id="element-114" />
    </svg>;
}